import validate from "/etc/buildAgent/work/74baefd00478bfe1/node_modules/nuxt/dist/pages/runtime/validate.js";
import coupon_45global from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/middleware/coupon.global.ts";
import drawer_45global from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/middleware/drawer.global.ts";
import keepalive_45global from "/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/middleware/keepalive.global.ts";
import manifest_45route_45rule from "/etc/buildAgent/work/74baefd00478bfe1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  coupon_45global,
  drawer_45global,
  keepalive_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authenticated: () => import("/etc/buildAgent/work/74baefd00478bfe1/packages/web-app/middleware/authenticated.ts")
}